module.exports = __webpack_public_path__ + "img/202412_05.5533cc12.jpg";